import FooterImg from "assets/images/footerImg.webp"
import { Col, Divider, Flex, Row } from "antd"
import { Button, Group, Icon, Image, Space, Text } from "components/common"
import FooterTagImg from "assets/images/footerTagImg.webp"
import FooterTagImg2 from "assets/images/footerTagImg2.webp"
import { Link } from "react-router-dom"
import AppStoreImg from "assets/images/App Store Link.webp"
import GooglePlayStoreImg from "assets/images/Google Play Link.webp"
import { useTranslation } from "react-i18next"
import styles from "./index.module.less"
import cx from "clsx"
import {
  BayutPlayStoreArabicIcon,
  BayutAppStoreIcon,
  BayutAppStoreArabicIcon,
  PlayStoreBadgeIcon,
} from "components/svg"
import AppLink from "components/common/layout/app-link"
import { Facebook, Instagram, LinkedIn, Twitter, Youtube } from "components/svg"
import Container from "components/common/container/contianer"
import React from "react"
import IconText from "components/common/iconText/iconText"
import { APPSTORE_URL, PLAYSTORE_URL, FACEBOOK_URL, TWITTER_URL, LINKEDIN_URL, INSTAGRAM_URL } from "ksa/constants/appLinks"
import { useMobile } from "hooks/useMobile"

import MinistryLogoAR from "assets/images/tourism-license-ar-update.png"
import MinistryLogoEN from "assets/images/tourism-license-update.png"
import RegaFalLogo from "assets/images/rega-fal-badge.svg"
import { useLanguage } from "hooks/useLanguage"
import { getAppLanguage } from "hooks/useLanguage"

const footerSocialLinks = [
  {
    key: "facebook",
    icon: "RiFacebookFill",
    style: { "--hover-bg": "#3b5998" },
    onClick: () => {
      window.open(FACEBOOK_URL, "_blank")
    },
  },
  {
    key: "twitter",
    icon: "RiTwitterXFill",
    style: { "--hover-bg": "#000" },
    onClick: () => {
      window.open(TWITTER_URL, "_blank")
    },
  },
  {
    key: "linkedin",
    icon: "RiLinkedinFill",
    style: { "--hover-bg": "#0e76a8" },
    onClick: () => {
      window.open(LINKEDIN_URL, "_blank")
    },
  },
  {
    key: "instagram",
    icon: "RiInstagramLine",
    className: styles.instagramLogo,
    style: { "--hover-bg": "#e1306c" },
    onClick: () => {
      window.open(INSTAGRAM_URL, "_blank")
    },
  },
]

const LowerFooter = () => {
  const { t } = useTranslation()
  const { isCurrentLanguageArabic } = useLanguage()
  const { isMobile, isTablet } = useMobile()
  const currentLang = getAppLanguage()
  const showMobileFooter = isMobile || isTablet
  const footerLinks = [
    {
      key: "helpSupport",
      title: t("HELP & SUPPORT"),
      link: isCurrentLanguageArabic ? "https://help.bayut.sa/hc/ar" : "https://help.bayut.sa/hc/en-us",
    },
    {
      key: "about",
      title: t("ABOUT US"),
      link: "/about-us",
    },
    {
      key: "advertise",
      title: t("ADVERTISE WITH BAYUT"),
      link: isCurrentLanguageArabic
        ? "https://www.bayut.sa/advertise-with-us/"
        : "https://www.bayut.sa/en/advertise-with-us/",
    },
    {
      key: "contact",
      title: t("CONTACT US"),
      link: "/contact-us",
    },
    {
      key: "terms",
      title: t("TERMS & PRIVACY POLICY"),
      link: "/terms",
    },
  ]

  return (
    <div className={styles.bayutFooter}>
      <Container customWidth="1320px">
        <Group
          template={showMobileFooter ? "initial" : "auto auto"}
          gap={showMobileFooter ? "22px" : "65px"}
          style={{ alignItems: "start" }}
        >
          <Flex align="start" gap="20px">
            <a href="./" style={{ margin: showMobileFooter && "auto" }}>
              <Flex
                as="a"
                align="center"
                target="_blank"
                href="https://eservicesredp.rega.gov.sa/auth/queries/Brokerage/BrokerageDetails/WB2Ma9gyrGeW4VLQR6NO/BrokerType_Office"
                rel="noreferrer"
                gap={showMobileFooter ? "10px" : "20px"}
              >
                <img
                  style={{ height: showMobileFooter ? "70px" : "101px", marginBlockStart: 7 }}
                  src={RegaFalLogo}
                  alt=""
                />
                <img
                  style={{ height: showMobileFooter ? "70px" : "98px", marginBlockStart: 7 }}
                  src={currentLang?.rtl ? MinistryLogoAR : MinistryLogoEN}
                  alt=""
                />
              </Flex>
            </a>
            {!isMobile && !isTablet && (
              <Flex vertical gap={10}>
                <div>
                  {footerLinks?.map((item, i) => (
                    <React.Fragment key={i}>
                      <Link className={styles.listItem} to={item?.link}>
                        {item?.title}
                      </Link>
                      {i !== footerLinks.length - 1 && (
                        <Divider
                          type="vertical"
                          style={{ borderColor: "#F5F5F5", marginInline: "10px", height: "15px" }}
                        />
                      )}
                    </React.Fragment>
                  ))}
                </div>
                {/* //Commenting this For now becuase there is only platform for now */}
                {/* <Flex gap={2} style={{ marginBottom: "18px" }}>
                  <Text color={"#dedede"} type="secondaryLight" style={{ marginInlineEnd: "6px" }}>
                    {`${t("COUNTRY")}: `}
                  </Text>

                  <IconText
                    gap="8px"
                    iconProps={{ size: "14px" }}
                    title="Saudi Arabia"
                    icon={"SaudiFlagIcon"}
                    textType="white"
                    align="end"
                    className={styles.countryField}
                  />
                </Flex> */}
                <Text type="secondaryLight">{`© 2008 -2025 ${t("Bayut.sa")}`}</Text>
              </Flex>
            )}
          </Flex>
          <div style={{ height: "100%" }}>
            <Flex vertical justify="space-between" gap="0px" style={{ height: "inherit" }}>
              <Flex gap="10px" justify={showMobileFooter && "center"}>
                <Flex justify={"end"} alignItems="start" gap={11} className={showMobileFooter ? "mbe-12" : "mbe-20"}>
                  {footerSocialLinks?.map((item, i) => (
                    <Button
                      className={cx(item.className, styles.hoverIcon, "hoverIcon")}
                      href={item.href}
                      icon={item.icon}
                      shape="circle"
                      style={item.style}
                      key={item.key}
                      iconSize="1.28571em"
                      bordered={false}
                      onClick={item?.onClick}
                    />
                  ))}
                </Flex>

                {!isMobile && !isTablet && (
                  <Flex className="badges mbe-40" align="center" gap="4px">
                    <AppLink
                      link={APPSTORE_URL}
                      target={"_blank"}
                      IconEn={BayutAppStoreIcon}
                      IconAr={BayutAppStoreArabicIcon}
                      width="110"
                      height="34.8"
                    />
                    <AppLink
                      link={PLAYSTORE_URL}
                      target={"_blank"}
                      IconEn={PlayStoreBadgeIcon}
                      IconAr={BayutPlayStoreArabicIcon}
                      height="34.8"
                    />
                  </Flex>
                )}
              </Flex>
              {!isMobile && (
                <Button
                  as={Button}
                  type="link"
                  className={cx("p-0", styles.scrollTop)}
                  align="center"
                  onClick={() => {
                    window.scrollTo({ top: 0, insetInline: 0, behavior: "smooth" })
                  }}
                  style={{ marginInlineEnd: -4, gap: 1 }}
                >
                  <span className="fs12 text-upcase" style={{ color: "#c1bfbf", marginBlockStart: 3 }}>
                    {t("Top")}
                  </span>

                  <Icon icon="IoChevronUpCircle" size="2.8em" className="m-0" />
                </Button>
              )}

              {showMobileFooter && (
                <Text
                  className={showMobileFooter && "fs12"}
                  style={{ margin: "auto" }}
                  type="secondaryLight"
                >{`© 2008 -2025 ${t("Bayut.sa")}`}</Text>
              )}
            </Flex>
          </div>
        </Group>
      </Container>
    </div>
  )
}

export default LowerFooter
